import React, { useState } from 'react'
import { Button, Checkbox, Divider, FormControlLabel, Grid, Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action'
import DropDownOA from '../../../../common/dropDownOA'
import { navigation3 } from '../../../../common/helper'
import { Item } from '../../../../common/snippets'
import { ApprAuthority, BookAccSpecialCheckBoxList } from '../../constants'
import InfoIcon from '@mui/icons-material/Info'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import {  userRRARBookAcSpecialRightsSave } from '../../../../../store/branchAndUserMaster/BUMAction'
import OTPModal from '../OTPModal'
import SuccessfullModal from '../../../../common/SuccessfullModal'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import { oTPForUserRoleRight } from '../../../../common/jotaiState/commonStateAtoms'


const AccountingRights = (props) => {
    const { data, updateModal, userRollRightSendOTP, userRRARBookAcSpecialRightsSave, setACRightsCheckValue, aCRightsCheckValue, otpOnUserRights, roleId,loginData } = props
    const { common } = data
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        paddingTop: '5%'
    }
    const [selApprAuth, setSelApprAuth] = useState("")
    const [OtpModal, setOtpModal] = useState(false)
    const [OTP, setOTP] = useState("")
    const [isOpen, setIsOpen] = useState({ open: false, message: "" })
    const [saveError, setSaveError] = useState({ error: false, message: "", })

    const sendOTPRequest = () => {
        const obj = {
            strOTPType: "UR",
            intCompanyId: loginData?.intCompanyID,
            intRoleID: roleId,
            intSaveType: 1,
            intOTPSendType: selApprAuth?.id
        }
        oTPForUserRoleRight(obj).then((res) => {
            if (res?.Status == true) {
                setOTP(res.OTP)
                setOtpModal(true)
            } else {
                setOTP("")
                updateAlertError({ show: true, msg: res.ErrMessage })
            }
        }).catch((err) => {
            updateAlertError({ show: true, msg: err })
        })
    }

    const saveApi = () => {
        const obj = {
            RoleID: roleId,
            AllowExpenseEntryChange: aCRightsCheckValue?.AllowExpenseEntryChange,
            AllowExpenseEntryApproval: aCRightsCheckValue?.AllowExpenseEntryApproval,
            AllowJournalEntryChange: aCRightsCheckValue?.AllowJournalEntryChange,
            AllowJournalEntryApproval: aCRightsCheckValue?.AllowJournalEntryApproval,
            AllowReceiptVoucherChange: aCRightsCheckValue?.AllowReceiptVoucherChange,
            AllowReceiptVoucherApproval: aCRightsCheckValue?.AllowReceiptVoucherApproval,
            AllowContraEntryChange: aCRightsCheckValue?.AllowContraEntryChange,
            AllowContraEntryApproval: aCRightsCheckValue?.AllowContraEntryApproval,
            AllowAnyDivision: aCRightsCheckValue?.AllowAnyDivision,
            BackdateDays: aCRightsCheckValue?.AccountingReportBackdateDaysRestriction,
            BaseUserID: loginData?.intUserID
        }
        userRRARBookAcSpecialRightsSave(obj).then((res) => {
            if (res?.status == 'Success') {
                setIsOpen({ ...isOpen, open: true, message: "Accounting Rights\nSaved Successfully!" })
            } else {
                setSaveError({ ...saveError, error: true, message: res.Message })
            }
        }).catch((err) => {
            setSaveError({ ...saveError, error: true, message: err })
        })
    }
    const onSave = () => {
        if (otpOnUserRights == 1) {
            if (selApprAuth === "") {
                updateAlertError({ show: true, msg: "Select Approval Authority", nextId: "UmAppAuth" })
            } else {
                sendOTPRequest()
            }
        } else {
            saveApi()
        }
    }

    const handleChange = (value, field) => {
        setACRightsCheckValue({ ...aCRightsCheckValue, [field]: value })
    }
    return (
        <>
            <Box sx={{ padding: "16px", paddingBottom: "0px", marginTop: "10px", paddingLeft: "16px" }}>
                <Grid container spacing={2} sx={{ display: "flex", alignItems: "start" }}>
                    {BookAccSpecialCheckBoxList.map((obj, i) =>
                        <Grid item md={obj.md} sx={{ paddingTop: "12px !important" }}>
                            <FormControlLabel
                                key={i}
                                value="end"
                                control={<Checkbox id={obj.id} checked={aCRightsCheckValue?.[obj.field] === 1} sx={{ padding: '0px 5px 0px 5px' }} />}
                                onKeyDown={(e) => {
                                    navigation3(e, obj.nextId, obj.prevId, () => { })
                                }}
                                label={
                                    <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                        {obj.label}
                                    </Typography>
                                }
                                onChange={(e) => handleChange(e.target.checked ? 1 : 0, obj.field)}
                                labelPlacement="end"
                            />
                        </Grid>
                    )}
                    <Grid item md={7}></Grid>
                </Grid>
            </Box>
            <Stack className="itemButtons beachTransBottomSec">
                <Divider />
                <Box className='reportButton' sx={{ display: 'flex', justifyContent: "space-between", padding: "16px", paddingBottom: "5px", gap: "12px" }}>
                    <Box style={{ display: "flex" }}>
                        <Item sx={sx.itemsx} style={{ width: "350px" }} className={'input--wrapper'}>
                            <DropDownOA
                                id={"UmAppAuth"}
                                data={ApprAuthority || []}
                                defaultvalue={selApprAuth?.name || ''}
                                width="100%"
                                searchPlaceholder={`Search Branch Name`}
                                label={"Approval Authority"}
                                dataKey={`name`}
                                idKey={`id`}
                                nextId={"UMActive"}
                                field={'compulsory'}
                                prevId={"UMPAN"}
                                onSelect={(value) => setSelApprAuth(value)}
                                direction='up'
                            />
                        </Item>
                        <Box style={{ marginLeft: "5px", display: "flex", alignItems: "center", gap: "5px", fontWeight: "500", fontSize: "13px" }}>
                            <InfoIcon style={{ color: "#0086FF" }} />
                            <span style={{ color: "#1E59A7" }}>OTP will send to the Management as per Selection</span>
                        </Box>
                    </Box>
                    <Box style={{ display: "flex", gap: "15px" }}>
                        <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMSave", "UMUserStatus", () => { })}>
                            <Button id={"UMCancel"} variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={() => updateModal(false, "LuggageRightsUseRollRights")}>
                                CANCEL
                            </Button>
                        </Item>
                        <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMUserName", "UMCancel", () => { })}>
                            <Button variant="contained" id="UMSave" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px" }} className="btn btn-primary"
                            onClick={() => onSave()}
                            >
                                Save
                            </Button>
                        </Item>
                    </Box>
                </Box>
                {/* */}
            </Stack>
            {OtpModal ? <OTPModal saveApi={saveApi} OTP={OTP} isOpen={isOpen} setIsOpen={setIsOpen} sendOTPRequest={sendOTPRequest} /> : ""}
            <SuccessfullModal modalStyle={modalStyle} handleClose={() => { setIsOpen({ ...isOpen, open: false, message: "" }); updateModal(false, "") }} open={isOpen?.open} title={isOpen?.message} />
            <SuccessAndErrorModal modalStyle={modalStyle} handleClose={() => setSaveError({ ...saveError, error: false })} isError={true} open={saveError.error} title={saveError?.message} />
        </>
    )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal, updateAlertError, userRRARBookAcSpecialRightsSave
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountingRights)